import { render, staticRenderFns } from "./MessageOverAll.vue?vue&type=template&id=a4755058"
import script from "./MessageOverAll.vue?vue&type=script&lang=js"
export * from "./MessageOverAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports